import React from 'react';

const AppLoadError: React.FunctionComponent<{}> = () => (
  /**
   * Component for showing an error when the app failed to load initially.
   * This component should have minimum amount of dependencies and should work on every environment.
   */

  <div style={{ marginTop: '32px', textAlign: 'center' }}>Could not load Wolt for Merchants. Please contact Wolt.</div>
);

export default AppLoadError;
